import React from 'react';
import { sentenceCase } from 'change-case';
import { PageHeader, Row, Col, Skeleton } from 'antd';

interface StackDetailCardPropsInterface {
    isLoadingData: boolean;
    stack: {
        id: number;
        apiJobId: number | null;
        createdAt: Date | string;
        status: string;
        client: {
            id: number;
            name: string;
        };
    };
}

const StackDetailCard: React.FC<StackDetailCardPropsInterface> = (
    props: StackDetailCardPropsInterface,
): React.ReactElement => {
    const {
        stack: { id, status, apiJobId, createdAt, client },
        isLoadingData,
    } = props;

    const renderStackedJobDetails = (): JSX.Element => {
        const stackDetailItems: { key: string; data: any }[] = [
            { key: 'middlewareId', data: id },
            { key: 'deliveryRequestId', data: apiJobId },
            { key: 'createdAt', data: createdAt },
            { key: 'clientName', data: client.name },
        ];

        return (
            <>
                {stackDetailItems.map((item) => (
                    <Row key={item.key}>
                        <Col span={12}>{`${sentenceCase(item.key)}:`}</Col>
                        <Col span={12} className="text-secondary">
                            {item.data}
                        </Col>
                    </Row>
                ))}
            </>
        );
    };

    if (isLoadingData) {
        return <Skeleton active />;
    }

    return (
        <div className="shadow-sm py-2 w-100">
            <PageHeader
                className="site-page-header py-2"
                title={<p className="h5 m-0">Stack</p>}
                extra={[
                    <p key="status">
                        <small>
                            <strong>Status:</strong>
                        </small>
                        <br />
                        <span className="text-secondary">{status}</span>
                    </p>,
                ]}
            />
            <div className="px-4">{renderStackedJobDetails()}</div>
        </div>
    );
};

export default StackDetailCard;
